import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, CardBody, Button, Input, InputGroup } from 'reactstrap';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import axios from 'axios';
import Swal from 'sweetalert2';

import env from '../../../env/src_config';
import { headersState, tokenState, wsIdState, wsNewMessageState, wsSubscribeToState } from '../../../recoil/recoil';
import { axiosError } from '../../../helpers/response';
import { displayDate, stringToColour } from '../../../izUtils';

const TaskChat = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const headers = useRecoilValue(headersState);
    const token = useRecoilValue(tokenState);
    const webSocketId = useRecoilValue(wsIdState);
    const webSocketNewMessage = useRecoilValue(wsNewMessageState);
    const setWebSocketSubscribeTo = useSetRecoilState(wsSubscribeToState);
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState('');

    // Get messages
    useEffect(() => {
        getMessages();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Add new message (from WS) to chat
    useEffect(() => {
        if (webSocketNewMessage !== null) {
            setMessages((prev) => [...prev, webSocketNewMessage])
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webSocketNewMessage])

    useEffect(() => {
        let container = document.querySelector(".chat-history");
        container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth'
        });
    }, [messages])

    const getMessages = () => {
        let payload = {
            data: {
                socket_id: webSocketId
            }
        }

        axios.post(env.api + '/api/task/message/' + id , payload, {headers}).then(response => {
           setMessages(response.data.comments.reverse());
           setWebSocketSubscribeTo({
                channel: "private-task."+id,
                auth: response.data.auth
            })
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const handleMessagePress = (e) => {
        if ((e.key === "Enter" || e === "send") && messageInput.length > 0 /*&& !e.shiftKey*/) {
            let payload = {
                save: true,
                data: {
                    message: messageInput
                }
            }

            axios.post(env.api + '/api/task/message/send/' + id , payload, {headers}).then(response => {
                if (response.data.state === 'success') {
                    setMessageInput('');
                } else {
                    Swal.fire({
                        title: t('error'),
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonColor: 'var(--theme-default)',
                        confirmButtonText: t('ok')
                    })
                }
             }).catch(error => {
                 axiosError(error, navigate);
             });
        }
    }

    return (
        <div>
            <Row>
                <Col className="call-chat-body">
                    <Card>
                        <CardBody className="p-0">
                            <div className="chat-box">
                                <Col className="pe-0 chat-right-aside">
                                    <div className="chat">
                                        <div className="chat-header clearfix">
                                            <div className="about">
                                                <div className="name">{"Pogovorno okno"}</div>
                                            </div>
                                        </div>
                                        <div className="chat-history chat-msg-box custom-scrollbar" >
                                            <ul>
                                                {messages.length > 0 &&
                                                    messages.map((message, index) => {
                                                        return (
                                                            <li key={index} className="clearfix">
                                                                <div className={`message my-message ${message.user.id !== token.parsedToken.id ? `` : 'float-end bg-primary text-white'}`} style={{ backgroundColor: `${stringToColour(message.user.name)}50` }}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <div><b>{message.user.name}</b></div>
                                                                        <div className="message-data text-end">
                                                                            <span className="message-data-time">{displayDate(message.created_at)}</span>
                                                                        </div>
                                                                    </div>
                                                                    {message.message}
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        </div>
                                        <div className="chat-message clearfix">
                                            <Row>
                                                <Col xl="12" className="d-flex">
                                                    <InputGroup className="text-box">
                                                        <Input
                                                            type="text"
                                                            className="form-control input-txt-bx"
                                                            placeholder="Napišite sporočilo..."
                                                            value={messageInput}
                                                            onKeyPress={(e) => handleMessagePress(e)}
                                                            onChange={(e) => setMessageInput(e.target.value)}
                                                        />
                                                        <Button className="input-group-text" color="primary" onClick={() => handleMessagePress('send')} >{"Pošlji"}</Button>
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default TaskChat